var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sketch_parent" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "sketch_order_footer" }, [
      _c(
        "div",
        { staticClass: "sketch_order_next_btn", on: { click: _vm.close } },
        [_vm._v("閉じる")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "sketch_main3" }, [
        _c("div", { staticClass: "sketch_up_title3" }, [_vm._v("送信完了")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      この度は、スケッチオーダーをご利用いただきありがとうございます。"
        ),
        _c("br"),
        _vm._v("\n      送信完了メールを自動送信しました。"),
        _c("br"),
        _vm._v(
          "\n      スタッフが対応してご連絡いたしますのでご連絡をお待ちください。"
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v("\n      対応可能時間は以下の通りです。"),
        _c("br"),
        _vm._v("\n      月〜金曜 10:00〜18:00 (定休：土日祝)"),
        _c("br"),
        _vm._v("\n      TEL: 03-6276-1123\n    ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-542cd502", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542cd502","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcSketchUploadComplete.vue
// module id = null
// module chunks = 